export { getWishlistServerAction } from 'next-flight-server-reference-proxy-loader?id=009f5868194906863bbb32ef789fc1645ddcc39a07&name=getWishlistServerAction!'